// Central content + asset map for NOIR PSYCHE. Easy to expand later.

export const IMAGES = {
  heroBust: "https://static.prod-images.emergentagent.com/jobs/444cfcdf-a921-4b89-ab9b-16dbb1cf58b1/images/12db75d6b2ee4ca4f09a5acb93caa3dbda9732a8e79e8bddbf348d83a633c64d.jpeg",
  heroWide: "https://static.prod-images.emergentagent.com/jobs/444cfcdf-a921-4b89-ab9b-16dbb1cf58b1/images/372071a502607db71f2f5aaa35d59a895e9e3b42e97332f4b0453d61016628ac.jpeg",
  aboutStatue: "https://static.prod-images.emergentagent.com/jobs/444cfcdf-a921-4b89-ab9b-16dbb1cf58b1/images/f7c9e0fd7831c2a689f678c0cce46b90498e8b191cbb15dadb32418eb0642cb2.jpeg",
  crackedMarble: "https://static.prod-images.emergentagent.com/jobs/444cfcdf-a921-4b89-ab9b-16dbb1cf58b1/images/46f6d7937728b5a2b31855b8b6d8ef67eaa5bf07ea2a1f7a5746ed20450b961b.jpeg",
};

export const VIDEOS = [
  {
    id: "v1",
    index: "01",
    title: "The Architecture of Manipulation",
    category: "Behavior",
    duration: "18:42",
    image: IMAGES.heroWide,
    span: "lg:col-span-8",
  },
  {
    id: "v2",
    index: "02",
    title: "Why the Mind Lies to Itself",
    category: "Consciousness",
    duration: "12:07",
    image: IMAGES.aboutStatue,
    span: "lg:col-span-4",
  },
  {
    id: "v3",
    index: "03",
    title: "The Shadow You Refuse to See",
    category: "Psychology",
    duration: "24:15",
    image: IMAGES.crackedMarble,
    span: "lg:col-span-4",
  },
  {
    id: "v4",
    index: "04",
    title: "Reading People Before They Speak",
    category: "Truth",
    duration: "15:53",
    image: IMAGES.heroBust,
    span: "lg:col-span-8",
  },
];

export const TOPICS = [
  { n: "01", title: "Psychology", desc: "The hidden machinery driving every decision you believe is your own." },
  { n: "02", title: "Behavior", desc: "Patterns beneath the surface — what people do when they think no one is watching." },
  { n: "03", title: "Consciousness", desc: "The observer behind the thought. Awareness as the final unexplored territory." },
  { n: "04", title: "Truth", desc: "Uncomfortable clarity. The frameworks most people spend a lifetime avoiding." },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "We study the unseen.",
    body: "Every gesture, silence, and impulse carries information. NOIR PSYCHE exists to decode the signals hiding in plain sight — the psychology the world overlooks.",
  },
  {
    n: "02",
    title: "Cinema meets cognition.",
    body: "We refuse the sterile lecture format. Each piece is crafted like film — deliberate, atmospheric, and designed to sit with you long after it ends.",
  },
  {
    n: "03",
    title: "Clarity is the product.",
    body: "No noise. No dopamine tricks. Only frameworks sharp enough to change how you read a room, a relationship, and yourself.",
  },
];

export const SOCIALS = [
  { key: "youtube", label: "YouTube", href: "https://youtube.com/@OfficialNoirPsyche" },
  { key: "instagram", label: "Instagram", href: "https://instagram.com/thenoirpsyche" },
  { key: "tiktok", label: "TikTok", href: "https://tiktok.com/@thenoirpsyche" },
  { key: "facebook", label: "Facebook", href: "https://facebook.com/NoirPsyche" },
  { key: "x", label: "X", href: "https://x.com/TheNoirPsyche" },
];

export const YOUTUBE_URL = "https://youtube.com/@OfficialNoirPsyche";
